import { HorizontalContainer, IconButton, Wrapper } from '@american-autonomy/ag-ui';

import CloseIcon from 'components/icons/CloseIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CLOSE_BUTTON_TEST_ID = 'modalHeaderCloseButton';

const ModalHeader: FunctionComponent<Props> = ({
    className = '',
    onClose,
    testId = TEST_ID,
    title
}) => (
    <HorizontalContainer className={`${styles.modalHeader} ${className}`} testId={testId}>
        <Wrapper className={styles.title}>{title}</Wrapper>

        <IconButton onClick={onClose} testId={CLOSE_BUTTON_TEST_ID}>
            <CloseIcon />
        </IconButton>
    </HorizontalContainer>
);

export default ModalHeader;
